import { gql } from "@apollo/client";export default gql`query chapterAggregate($parent_id: Int!) {
    chapterAggregate: group_aggregate(where: {parent_id: {_eq: $parent_id}, type: {_eq: "chapter"}}) {
        aggregate {
            count
        }
    }
}
`;
